/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Nyakiriba 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */

module.exports = {
  "Bisizi": [
    "Bweza",
    "Gisangani",
    "Kamakinga",
    "Kibuye",
    "Kingoma",
    "Mwumba",
    "Nyamwishyura",
    "Runaba"
  ],
  "Gikombe": [
    "Kitarimwa",
    "Nyabibuye",
    "Nyabirezi",
    "Nyakibande",
    "Rugerero",
    "Rushubi"
  ],
  "Kanyefurwe": [
    "Kayove",
    "Kiyovu",
    "Muhira",
    "Nyakabungo",
    "Rebero",
    "Rukoro"
  ],
  "Nyarushyamba": [
    "Bazirete",
    "Kivumu",
    "Makoro",
    "Nyonirima",
    "Ruhangiro",
    "Runyeheri",
    "Ruvuzananga"
  ]
};
